import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { LangService, Language } from './lang.service';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private translations: { [key: string]: any } = {};
  private currentLang: Language = 'en';

  constructor(private http: HttpClient, private langService: LangService) {
    this.langService.currentLang$.subscribe((lang) => {
      this.currentLang = lang;
      this.loadTranslations(lang);
    });
  }

  public loadTranslations(lang: Language): void {
    const langFile = `assets/i18n/${lang}.json`;

    this.http
      .get(langFile)
      .pipe(
        catchError((error) => {
          return of({});
        })
      )
      .subscribe((translations) => {
        this.translations = translations;
      });
  }

  translate(key: string): string {
    // Handle nested keys like "login.welcome_back"
    const keys = key.split('.');
    let value: any = this.translations;

    for (const k of keys) {
      if (value && typeof value === 'object' && value[k] !== undefined) {
        value = value[k];
      } else {
        return key; // Return the key if translation not found
      }
    }

    const result = typeof value === 'string' ? value : key;
    if (result === key) {
    }
    return result;
  }

  getCurrentLang(): Language {
    return this.currentLang;
  }

  isRTL(): boolean {
    return this.langService.getCurrentLang() === 'ar';
  }
}
